module.exports = __webpack_public_path__ + "static/media/SandhavenCliff.e00760ca.png";